import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import PopularRanking from "@/pages/home/components/PopularRanking";
import SectionHeader from "@/components/feature/SectionHeader";
import MovieCard from "@/components/feature/MovieCard";
import { getLatest, getPopular } from "@/lib/media";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta(
    "最近中文字幕 - 最新影视资源与中文字幕更新平台",
    "最近中文字幕网站为用户提供最新影视作品的中文字幕信息和资源，涵盖电影、电视剧等多个类别，帮助用户快速找到想看的带中文字幕内容。",
    "最近中文字幕,中文字幕,最新影视,影视资源,中文字幕电影,中文字幕电视剧,影视更新,字幕下载"
  );

  const latest = getLatest(10);
  const popular = getPopular(6);

  return (
    <div className="animate-fade-up">
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <section className="pt-10 md:pt-14">
          <SectionHeader
            title="分类快捷入口"
            subtitle="按类别快速进入，查看对应专区的中文字幕更新"
            icon="ri-layout-grid-line"
          />
          <div className="mt-5">
            <CategoryEntries />
          </div>
        </section>

        <section className="pt-12 md:pt-16">
          <SectionHeader
            title="最新更新"
            subtitle="按更新时间倒序展示带中文字幕的最新影视作品"
            icon="ri-time-line"
            actionText="查看电影专区"
            actionTo="/category/movie"
          />
          <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {latest.map((item) => (
              <MovieCard key={item.id} item={item} />
            ))}
          </div>
        </section>

        <section className="pt-12 md:pt-16">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px] lg:gap-8">
            <div>
              <SectionHeader
                title="热门推荐"
                subtitle="按观看量与更新频率综合排序，看看大家都在追什么"
                icon="ri-fire-line"
              />
              <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4">
                {popular.map((item) => (
                  <MovieCard key={item.id} item={item} />
                ))}
              </div>
            </div>
            <div className="mt-2 lg:mt-0">
              <SectionHeader title="人气榜单" icon="ri-trophy-line" />
              <div className="mt-5">
                <PopularRanking items={getPopular(8)} />
              </div>
            </div>
          </div>
        </section>

        <section id="site-content" className="py-12 md:py-16">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr]">
              <div className="p-6 md:p-10">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                  <i className="ri-closed-captioning-line"></i>
                  关于本站
                </span>
                <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                  最近中文字幕 · 最新影视资源与中文字幕更新平台
                </h1>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                  本站专注于汇总最新影视作品的中文字幕更新信息，涵盖电影与电视剧两大类别。
                  你可以按类型、年份筛选资源，通过关键词快速检索，并查看每部作品的简介与字幕更新情况。
                  我们会持续同步带中文字幕的新内容，帮助中文影视爱好者高效发现想看的作品。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link
                    to="/category/movie"
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-film-line"></i>
                    浏览电影
                  </Link>
                  <Link
                    to="/about"
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    <i className="ri-information-line"></i>
                    了解本站
                  </Link>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-px bg-background-200 lg:grid-cols-1">
                {[
                  { label: "收录作品", value: "20+", icon: "ri-database-2-line" },
                  { label: "电影 / 电视剧", value: "12 / 8", icon: "ri-movie-2-line" },
                  { label: "字幕更新", value: "每日", icon: "ri-refresh-line" },
                  { label: "支持筛选", value: "类型 · 年份", icon: "ri-filter-3-line" },
                ].map((stat) => (
                  <div key={stat.label} className="flex flex-col justify-center bg-background-50 p-5 md:p-6">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-600">
                      <i className={stat.icon}></i>
                    </span>
                    <span className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                      {stat.value}
                    </span>
                    <span className="mt-1 text-xs text-foreground-500">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}